export default __webpack_public_path__ + "panton_white_extrabold-7ca04449db018d92e9fe130f2fbc90b9.xml";